import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import Card from '../../shared/components/UIElements/Card';
import Modal from '../../shared/components/UIElements/Modal';

import { AuthContext } from '../../shared/context/auth-context';

import './UserItem.css';

// Footer
//import Footer from '../../shared/components/UIElements/Footer';

const UserItem = props => {

    const auth = useContext(AuthContext);

    const user = props.user;

    const [showContactModal, setShowContactModal] = useState(false);

    const [showLoginModal, setShowLoginModal] = useState(false);

    /*
    const openContactHandler = () => {
        setShowContactModal(true);
    };
    */

    const openContactHandler = () => {
        if (!auth.isLoggedIn) {
            setShowLoginModal(true);
            return;
        }

        setShowContactModal(true);
    };

    const closeContactHandler = () => {
        setShowContactModal(false);
    };

    return (
        <React.Fragment>

            {/* =========================
                CONTACT MODAL
            ========================== */}
            <Modal
                show={showContactModal}
                onCancel={closeContactHandler}
                header="Contact Details"
                footer={
                    <button onClick={closeContactHandler}>
                        CLOSE
                    </button>
                }
            >
                <h2>Call: {user.mobile}</h2>
                <h2>Email: {user.email}</h2>

                {user.whatsAppNumber && (
                    <h2>WhatsApp: {user.whatsAppNumber}</h2>
                )}
            </Modal>

            <Modal
                show={showLoginModal}
                onCancel={() => setShowLoginModal(false)}
                header="Login Required"
                footer={
                    <button onClick={() => setShowLoginModal(false)}>
                        CLOSE
                    </button>
                }
            >
                <p>
                    Please create an account or log in to view contact details.{' '}
                    <Link to="/auth">Signup/Login</Link>
                </p>
            </Modal>


            {/* =========================
                USER CARD
            ========================== */}
            <li className="user-item">

                <Card className="user-item__content">

                    <div className="user-item__layout">

                        {/* =========================
                            PERSONAL INFO
                        ========================== */}
                        <div className="user-item__section personal-info">

                            {/*<h3>Personal Info</h3>*/}

                            <div className="personal-info__details">

                                <h2>
                                    {/*<strong>Name:</strong> {user.name}*/}
                                    <strong>{user.name}</strong>
                                </h2>

                                <h2>
                                    |
                                </h2>

                                <h2>
                                    {/*<strong>Gender:</strong> {user.gender}*/}
                                    {user.gender}
                                </h2>

                                <h2>
                                    {/*<strong>City:</strong> {user.city}*/}
                                    {user.city}
                                </h2>

                            </div>

                        </div>


                        {/* =========================
                            KEY SKILLS
                        ========================== */}
                        <div className="user-item__section interests">

                            <h3>Key Skills</h3>

                            {user.interests &&
                                user.interests.some(
                                    interest =>
                                        interest &&
                                        interest.trim() !== ''
                                ) ? (
                                <ul className="interest-list">

                                    {user.interests
                                        .filter(
                                            interest =>
                                                interest &&
                                                interest.trim() !== ''
                                        )
                                        .map((interest, index) => (
                                            <li key={index}>
                                                {interest}
                                            </li>
                                        ))}

                                </ul>
                            ) : (
                                <p className="no-data">
                                    No skills available
                                </p>
                            )}

                        </div>


                        {/* =========================
                            SERVICES OFFERED
                        ========================== */}
                        <div className="user-item__section services">

                            <h3>Services Offered</h3>

                            {user.services &&
                                user.services.some(
                                    service =>
                                        service &&
                                        service.trim() !== ''
                                ) ? (
                                <ul className="service-list">

                                    {user.services
                                        .filter(
                                            service =>
                                                service &&
                                                service.trim() !== ''
                                        )
                                        .map((service, index) => (
                                            <li key={index}>
                                                {service}
                                            </li>
                                        ))}

                                </ul>
                            ) : (
                                <p className="no-data">
                                    No services available
                                </p>
                            )}

                        </div>


                        {/* =========================
                            RATE CARD + ACTIONS
                        ========================== */}
                        <div className="user-item__section charges">

                            <div className="charges-row">

                                <h3>
                                    Starts with - Rs.{' '}
                                    {user.rateCard?.consultation || 'N/A'}
                                    {' '}Consultation
                                </h3>


                                <div className="charges-actions">

                                    {/* CONTACT BUTTON */}
                                    <button
                                        className="contact-btn"
                                        onClick={openContactHandler}
                                    >
                                        Contact
                                    </button>


                                    {/* VIEW MORE */}
                                    <Link
                                        to={`/${user.userId}/profile`}
                                        className="view-more-link"
                                    >
                                        View More
                                    </Link>

                                </div>

                            </div>

                        </div>

                    </div>

                </Card>

            </li>


            {/* =========================
                FOOTER
            ========================== */}
            {/*<Footer />*/}

        </React.Fragment>
    );
};

export default UserItem;
